export const CHAT_VOTING_TALLY_ELEMENT_KIND = "chat_voting.tally" as const;
